import { Box } from "@material-ui/core";
import { isEmptyArray, useFieldInitialValue } from "formik";
import { useEffect, useState } from "react";
import { combinePaths, isSectionEmbedded } from "../../models/flexible/utils";
import { isEmptyObject } from "../../utils/is-empty-object";
import { SectionBodyInstances } from "./SectionBodyInstances";
import { SectionHeader } from "./SectionHeader";
import { ISectionRenderProps } from "./SectionRoot";

export const DesignedSection: React.FC<ISectionRenderProps> = (props) => {
	const { controller, parentPath: path } = props;
	const [isOpen, setOpen] = useState(false);
	const isOpenByDefault = controller.useIsSectionOpenByDefault ? controller.useIsSectionOpenByDefault() : true;
	const isOpenedConditionally = controller.useIsSectionOpenedConditionally ? controller.useIsSectionOpenedConditionally() : false;
	const sectionPath = isSectionEmbedded(controller.schema) ? path : combinePaths(path, controller.schema.localizableKey);
	const initialValue = useFieldInitialValue(sectionPath);

	if (!controller.context.isEditable && (Array.isArray(initialValue) ? !initialValue.length : isEmptyObject(initialValue))) {
		return <></>;
	}

	useEffect(() => {
		const isSetOpenByData = initialValue && (Array.isArray(initialValue) ? !isEmptyArray(initialValue) : !isEmptyObject(initialValue));
		if (isSetOpenByData || isOpenByDefault) {
			setOpen(true);
		}
	}, [initialValue, controller, setOpen, isOpenByDefault]);

	function handleSwitchState() {
		setOpen(!isOpen);
	}

	return (
		<Box width="100%">
			{controller.renderBeforeHeader?.(sectionPath)}
			{controller.schema.isHeaderShown && (
				<SectionHeader controller={controller} isOpen={isOpen} handleSwitchState={handleSwitchState} />
			)}
			{(isOpen || isOpenedConditionally) && (
				<Box>
					{controller.renderAfterHeader?.(sectionPath)}
					<SectionBodyInstances {...props} />
				</Box>
			)}
		</Box>
	);
};
